
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import {VueInject} from "@/VueIntegration/VueInjectable";
import {ClosedCaptionsService, SlideAction} from "@/ClosedCaptionsService";
import {Synchroniser} from "@/Synchroniser";
import {Slideshow} from "@/slideshow";
import {PubSub} from "@/Core/PubSub";
import VueButton from "./VueButton.vue";
import {TransitionType} from "@/Core/SlideTransition";
import {toLocal} from "@/i18n/MultilingualText";

@Component({
    components: {VueButton}
})
export default class ReaderModeSlide extends Vue {
    @Prop({required: true}) id: string;

    @VueInject("ClosedCaptionsService") closedCaptionsService: ClosedCaptionsService;
    @VueInject("Synchroniser") sync: Synchroniser;
    @VueInject("Slideshow") slideshow: Slideshow;
    @VueInject("PubSub") pubSub: PubSub;

    content: string[] = [];
    actions: SlideAction[] = [];

    mounted() {
        this.enter();
    }

    @Watch('id')
    enter() {
        let transition = this.slideshow.currentSlide.transition;
        if (transition.type === TransitionType.Choice) {
            this.actions = transition.choices.map(x => ({slideId: x.id, text: toLocal(x.text)}));
        }
        else {
            this.actions = [];
        }

        // Grab the text from the closed captions
        let captions = this.closedCaptionsService.getSlideDescriptionForCurrentSlide();
        let result = [];
        let currentString = "";
        let prependSpace = false;

        for (let i = 0; i < captions.length; i++){
            let caption = captions[i];
            let trimmed = caption.text.trim();

            if (prependSpace) {
                currentString += " " + trimmed;
            }
            else {
                currentString += trimmed;
                prependSpace = true;
            }

            if (i === captions.length - 1 || isEndOfSentence(trimmed)) {
                result.push(currentString);
                currentString = "";
                prependSpace = false;
            }
        }

        this.content = result;
        this.slideshow.slideEntered();

        (<HTMLElement> this.$refs["content"]).focus();
    }

    nextSlide() {
        this.slideshow.nextSlide();
    }

    selectAction(action: SlideAction) {
        this.slideshow.nextSlide(action.slideId);
    }
}

function isEndOfSentence(str: string) {
    return /[.?!]$/g.test(str);
}
